import React, { Component } from 'react';

export default class ImageCard extends Component {

    render() {
        return (
            <div className="image-card" onClick={() => {this.props.partSelectHandler(this.props.item.id, this.props.item.image)}}>
                <img alt={this.props.item.name} src={this.props.item.image} />
            </div>
        )
    }
}